import { INode } from 'shared/types/tree'
import { LanguageCode } from './types'
import { isReferenceNode, traverseTree } from '../../utility/TreeHelpers'
import { idsForNode, UpdateMethod, UpdateType } from '../nodeUpdates/utility'
import { UpdateNodeUpdateData } from '../nodeUpdates/types'
import { getLangCodeForNode } from '../nodeCrossAssociation/utility'

export const availableLanguages: { code: LanguageCode; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Spanish' },
]

export function updateParamsForBranch({
  tree,
  language,
  branch,
}: {
  tree: INode
  branch: INode
  language: LanguageCode
}) {
  const lang = getLangCodeForNode(branch.id, tree) ?? language
  return updateBranchParams({ lang, branch })
}

function updateBranchParams({
  lang,
  branch,
}: {
  branch: INode
  lang: LanguageCode
}) {
  const toUpdate: UpdateNodeUpdateData[] = []
  const completed: string[] = []
  let different = 0

  for (const node of traverseTree(branch)) {
    if (isReferenceNode(node)) {
      continue
    }
    if (node.body?.lang === lang) {
      completed.push(node.id)
    } else {
      if (node.body?.lang) {
        different++
      }
      toUpdate.push({
        type: UpdateType.node,
        ids: idsForNode(node),
        params: {
          body: {
            ...node.body,
            lang,
          },
        },
        method: UpdateMethod.update,
      })
    }
  }

  return { toUpdate, completed, different }
}
